import { render, staticRenderFns } from "./goodsTagLog.vue?vue&type=template&id=59f4bafd&scoped=true&"
import script from "./goodsTagLog.vue?vue&type=script&lang=js&"
export * from "./goodsTagLog.vue?vue&type=script&lang=js&"
import style0 from "./goodsTagLog.vue?vue&type=style&index=0&id=59f4bafd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4bafd",
  null
  
)

export default component.exports